__webpack_require__.p = "/react-chat-widget/public/";